/*
 * Copyright (c) 2024, WSO2 LLC. (http://www.wso2.com). All Rights Reserved.
 *
 * This software is the property of WSO2 LLC. and its suppliers, if any.
 * Dissemination of any information or reproduction of any material contained
 * herein is strictly forbidden, unless permitted by WSO2 in accordance with
 * the WSO2 Commercial License available at http://wso2.com/licenses.
 * For specific language governing the permissions and limitations under
 * this license, please see the license as well as any agreement you’ve
 * entered into with WSO2 governing the purchase of this software and any
 * associated services.
 */

import { SubscriptionPolicy } from "../../data/interfaces";
import {
  FETCH_SUBSCRIPTION_POLICIES_FOR_ORGANIZATION_FAILURE,
  FETCH_SUBSCRIPTION_POLICIES_FOR_ORGANIZATION_REQUEST,
  FETCH_SUBSCRIPTION_POLICIES_FOR_ORGANIZATION_SUCCESS,
} from "../types/subscriptionPolicies";

export const fetchSubscriptionPoliciesRequest = () => {
  return {
    type: FETCH_SUBSCRIPTION_POLICIES_FOR_ORGANIZATION_REQUEST,
  };
};

export const fetchSubscriptionPoliciesSuccess = (
  subscriptionPolicies: SubscriptionPolicy[]
) => {
  return {
    type: FETCH_SUBSCRIPTION_POLICIES_FOR_ORGANIZATION_SUCCESS,
    payload: subscriptionPolicies,
  };
};

export const fetchSubscriptionPoliciesFailure = (error: string) => {
  return {
    type: FETCH_SUBSCRIPTION_POLICIES_FOR_ORGANIZATION_FAILURE,
    playload: error,
  };
};
